import { StarIcon } from "@heroicons/react/24/solid";
import React from "react";

const StartRating = ({
  className = "",
  point = 4.5,
  reviewCount,
  reviewStart,
}) => {
  return (
    <div
      className={`nc-StartRating flex items-center space-x-1 text-sm  ${className}`}
      data-nc-id="StartRating">
      <div className="pb-[2px]">
        <StarIcon className="w-[18px] h-[18px] text-orange-500" />
      </div>
      <span className="font-semibold text-black dark:text-white">{reviewStart}</span>
      <span className="text-neutral-500 dark:text-neutral-400">
        ({reviewCount})
      </span>
    </div>
  );
};

export default StartRating;
